var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isOpen)?_c('aside',{staticClass:"h-5/6 fixed bottom-0 bg-white ease-in-out transition-all duration-300 z-50 rounded-lg shadow-lg border",class:[_vm.transformClasses]},[_c('div',{staticClass:"p-2 bg-white"},[_vm._t("fixedTop")],2),_c('div',{staticClass:"h-full overflow-y-auto"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }